"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetMailSuffixRequest = void 0;
var GetMailSuffixRequest = /** @class */ (function () {
    function GetMailSuffixRequest() {
    }
    return GetMailSuffixRequest;
}());
exports.GetMailSuffixRequest = GetMailSuffixRequest;
;
//# sourceMappingURL=getMailSuffix.request.js.map